@use "../../variables" as *;
@use "../../mixins" as *;

.grid-container {
  flex: 1;

  h1 {
    justify-self: center;
    font-weight: 550;
    color: #555555;
    text-transform: uppercase;
    position: relative;
    z-index: 3;

    @include desktop; @include tablet {
    margin-top: -3.2rem;
    margin-left: -15rem;
  }

    @include mobile {
      font-size: 1rem;
      margin-top: 1rem;
      margin-bottom: 2.5rem;
      margin-left: 1.5rem;
    }
  }

  .bubble-filter-container {
    display: flex;
    flex-direction: row;
    overflow: scroll;
    width: 100vw;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    margin-bottom: 1rem;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .detail-view-hint-mobile {
    font-size: 0.6875rem;
    margin: 1.5625rem 0 1.5rem;
    padding: 0 0.75rem 0;
    letter-spacing: 0.034375rem;
    line-height: 1.25rem;
    text-align: left;

    @include tablet {
      display: none;
      margin: 0;
    }
  }

  .back-to-top {
    position: fixed;
    background: white;
    border-radius: 6rem;
    padding: 0.5rem;

    span {
      display: block;
    }

    @include desktop {
      bottom: 5rem;
      right: 5rem;

      span {
        width: 2.25rem;
        height: 2.25rem;
      }

      svg {
        width: 2.25rem;
        height: 2.25rem;
      }

      :hover {
        cursor: pointer;
      }
    }
    @include mobile {
      bottom: 2rem;
      right: 2rem;
    }
  }

  .product-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 5rem;

    .hidden {
      visibility: hidden;
    }

    > a {
      margin: 0 0 0.75rem 0;
      width: calc(50% - 0.5rem);

      @include tablet {
        width: calc(33% - 1rem);
        max-width: 17.5rem;
        margin: 0 0 1.856rem 0;
      }

      @media screen and (max-width: 360px - 1px) {
        width: 100%;
      }
    }
  }

  .no-products {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $white-ter;
    border-bottom-right-radius: 2rem;
    border-bottom-left-radius: 2rem;

    @include mobile {
      border-radius: 0;
      height: 100vh;
    }

    .info-text {
      color: $grey-text;
      font-size: 1.5rem;
      text-align: center;
      font-weight: 300;
      padding: 4.5rem;
      line-height: 2.25rem;

      @include mobile {
        font-size: 1rem;
        padding: 4rem 2rem 0;
        line-height: 1.75rem;
      }
    }

    .filter-reset {
      width: 65%;
      margin-top: 4rem;

      @include tablet {
        width: 40%;
        margin-top: 0;
        margin-bottom: 5rem;
      }
      
      a {
        text-decoration: none;
      }
    }
  }
}
